// extracted by mini-css-extract-plugin
module.exports = {"textImageSlider":"textImageSlider-module--textImageSlider--1kKO7","textImageSliderContent":"textImageSlider-module--textImageSliderContent--1UHSa"};